import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SystemParametersDto } from '@nebula-shared/domain';
// ✅ Cambia estos imports a rutas relativas
import { API_CONFIG } from '../crud/api.config';
import { HttpService } from '../http/http.service';

export type Module = keyof typeof API_CONFIG;

@Injectable({
  providedIn: 'root',
})
export class DateRangePickerServices {
  protected http = inject(HttpService);

  getSystemParams(module: Module): Observable<SystemParametersDto> {
    const config = API_CONFIG[module];
    return this.http.getContent<SystemParametersDto>(
      `${config.baseUrl}${config.endpoints?.parametrosSistema}/system-date`,
    );
  }
}
